import { HttpClient, HttpClientModule, provideHttpClient, withInterceptors } from '@angular/common/http';
import { ErrorHandler, inject, NgModule, provideAppInitializer } from '@angular/core';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TRANSLATE_HTTP_LOADER_CONFIG,TranslateHttpLoader } from '@ngx-translate/http-loader';
import * as Sentry from '@sentry/angular';
import { NgxFileDropModule } from 'ngx-file-drop';
import { MarkdownModule } from 'ngx-markdown';
import { NgxPermissionsModule } from 'ngx-permissions';
import { progressInterceptor, provideNgProgressHttp } from 'ngx-progressbar/http';
import { ToastrModule } from 'ngx-toastr';

import { appInitializerProviders, BASE_URL, httpInterceptorProviders } from '@core';
import { CoreModule } from '@core/core.module';
import { environment } from '@env/environment';
import { SharedModule } from '@shared/shared.module';
import { ThemeModule } from '@theme/theme.module';

import { LoginService } from '@core/authentication/login.service';

import { AppComponent } from './app.component';
import { RoutesModule } from './routes/routes.module';

export function createTranslateLoader(): TranslateLoader {
  return new TranslateHttpLoader();
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    CoreModule,
    ThemeModule,
    RoutesModule,
    SharedModule,
    NgxPermissionsModule.forRoot(),
    ToastrModule.forRoot(),
    MarkdownModule.forRoot({
      loader: HttpClient,
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [],
      },
    }),
    BrowserAnimationsModule,
    NgxFileDropModule,
  ],
  providers: [
    { provide: ErrorHandler, useValue: Sentry.createErrorHandler({ showDialog: false, }) },
    { provide: Sentry.TraceService, deps: [Router] },
    provideAppInitializer(() => { inject(Sentry.TraceService); }),  // Initialize Sentry TraceService
    { provide: BASE_URL, useValue: environment.baseUrl },
    { provide: LoginService }, // <= Remove it in the real APP
    { provide: TRANSLATE_HTTP_LOADER_CONFIG, useValue: { prefix: './assets/i18n/', suffix: '.json' } },
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: { verticalPosition: 'top', panelClass: 'info' },
    },
    httpInterceptorProviders,
    appInitializerProviders,
    provideNgProgressHttp({
      silentApis: ['/api/lmr/agent-runs/', '/api/lmr/review/assigned'],
    }),
    provideHttpClient(withInterceptors([progressInterceptor])),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
